import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { NotificationService } from '../../core/services/notification.service';
import { StudioService } from '../../core/services/studio.service';
import { TransactionService } from '../../core/services/transaction.service';
import { FormFeedback } from '../../shared/components/form-feedback.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-notification-plan',
    imports: [RouterLink, FormsModule, DatePipe, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
    </div>
    <div class="card-body">
      <div style="height: 1px"></div>
      <form #notificationForm="ngForm" novalidate name="notificationForm" class="col-md-12" (ngSubmit)="save(notificationForm)">
        <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        <div class="row">
          <div class="col-md-3 text-md-right">会員ID：</div>
          <div class="col-md-3 form-group">{{ member?.memberCode }}</div>
          <div class="col-md-3 text-md-right">会員氏名：</div>
          <div class="col-md-3 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
          <div class="col-md-3 text-md-right">店舗：</div>
          <div class="col-md-3 form-group">{{ member?.studio?.name }}</div>
          <div class="col-md-3 text-md-right">状態：</div>
          <div class="col-md-3 form-group">
            @if (member?.status == 0) { <span>在籍中</span> }
            @if (member?.status == 1) { <span>停止</span> }
            @if (member?.status == 2) { <span>停止（除名）</span> }
          </div>
          <div class="col-md-3 text-md-right">区分コース：</div>
          <div class="col-md-3 form-group">{{ member?.studioPlan?.name }}</div>
          <div class="col-md-3 text-md-right">支払方法：</div>
          <div class="col-md-3 form-group">
            @if (member?.payment?.paymentMethod == 0) { <span>口座振替</span> }
            @if (member?.payment?.paymentMethod == 1) { <span>クレジットカード</span> }
          </div>
          <div class="col-md-3 text-md-right">ロッカー：</div>
          <div class="col-md-3 form-group">
            @if (member?.lockerNumber == null) { <span>使用しない</span> }
            @if (member?.lockerNumber != null) { <span>{{ member?.lockerNumber?.product?.name }}</span> }
          </div>
          <div class="col-md-3 text-md-right">保険適応：</div>
          <div class="col-md-3 form-group">
            @if (member?.isInsured == 0) { <span>なし</span> }
            @if (member?.isInsured == 1) { <span>あり</span> }
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-form-label">区分コース</label>
                <select class="form-control" [(ngModel)]="select.studioPlan" name="studioPlanId" required>
                  <option [ngValue]="null">選択してください</option>
                  @for (p of plans; track p.id) {
                    <option [ngValue]="p">{{ p.name }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-form-label">区分コース変更月</label>
                <select class="form-control" [(ngModel)]="select.startDate" name="startDate" required>
                  <option [ngValue]="null">選択してください</option>
                  @for (opt of startDateOptions; track opt.id) {
                    <option [ngValue]="opt">{{ opt.name }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">現区分コース価格での最終お支払日：{{ select.startDate?.lastBillingMonth | date: (member?.payment?.paymentMethod == 0 ? 'yyyy年MM月' : 'yyyy年MM月dd日') }}{{ select.startDate && member?.payment?.paymentMethod == 0 ? '末' : '' }}</label>
              </div>
              <div class="col-md-12">
                <label class="col-form-label">変更先区分コース価格での初回お支払日：{{ select.startDate?.firstBillingMonth | date: (member?.payment?.paymentMethod == 0 ? 'yyyy年MM月' : 'yyyy年MM月dd日') }}{{ select.startDate && member?.payment?.paymentMethod == 0 ? '末' : '' }}</label>
              </div>
            </div>
          </div>
        </div>
        <br /><br />
        <div class="row">
          <div class="col-md-12 text-right">
            <a [routerLink]="['/notification', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
            <button type="submit" class="btn btn-success" [disabled]="notificationForm.invalid || saving || completed || member?.status != 0"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class NotificationPlanComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private notificationService = inject(NotificationService);
  private flash = inject(FlashService);
  private studioService = inject(StudioService);
  private transactionService = inject(TransactionService);
  private route = inject(ActivatedRoute);

  private batchDay = 11;
  memberId!: number;
  member: any = null;
  plans: any[] = [];
  startDateOptions: any[] = [];
  select: any = { studioPlan: null, startDate: null };
  saving = false;
  completed = false;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員別諸届申請', 'fa fa-inbox');
    this.memberId = +this.route.snapshot.params['memberId'];
    this.batchDay = await this.transactionService.getBatchSchedule().catch(() => 11) ?? 11;
    this.member = await this.memberService.getOne(this.memberId);
    const studioId = this.member?.studio?.id ?? this.member?.studioId;
    if (studioId) {
      const studioData: any = await this.studioService.list(studioId);
      const studio = Array.isArray(studioData) ? (studioData[0] ?? {}) : (studioData ?? {});
      this.plans = (studio.studioPlans ?? studio.studioPlan ?? studio.plans ?? []).filter((p: any) => p.id !== this.member?.studioPlan?.id);
    }
    this.startDateOptions = this.buildStartDateOptions(this.batchDay);
  }

  buildStartDateOptions(batchDay: number): any[] {
    const now = new JstDate();
    const startDateModify = batchDay <= now.getDate() ? 1 : 0;
    const billingMonthModify = Number(this.member?.payment?.paymentMethod ?? 0);
    const options = [];
    for (let i = 1; i <= 2; i++) {
      const startDate = new JstDate(now.getFullYear(), now.getMonth() + i + startDateModify, 1);
      options.push({
        id: startDate.getFullYear() + '-' + (startDate.getMonth() + 1),
        name: String(startDate.getFullYear()) + '年' + ('0' + String(startDate.getMonth() + 1)).slice(-2) + '月',
        date: startDate,
        lastBillingMonth: new JstDate(startDate.getFullYear(), startDate.getMonth() - 2 + billingMonthModify),
        firstBillingMonth: new JstDate(startDate.getFullYear(), startDate.getMonth() - 1 + billingMonthModify),
      });
    }
    return options;
  }

  async save(form?: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (form?.invalid || this.saving || this.completed || this.member?.status != 0) return;
    this.saving = true;
    try {
      const json = {
        studioId: this.member.studio.id,
        memberId: this.member.id,
        requestMonth: new JstDate().getFullYear() + '-' + ('0' + (new JstDate().getMonth() + 1)).slice(-2),
        requestType: 3,
        startDate: this.select.startDate?.date,
        beforeStudioPlanId: this.member.studioPlan?.id,
        afterStudioPlanId: this.select.studioPlan?.id,
      };
      const result = await this.notificationService.upsert(json);
      if (!result) {
        this.showFeedback('danger', '諸届申請を更新できませんでした');
        return;
      }
      this.completed = true;
      this.resetInputs(form);
      this.showFeedback('success', '諸届申請を更新しました');
    } finally {
      this.saving = false;
    }
  }

  private showFeedback(type: FormFeedback['type'], text: string): void {
    // 旧版 notification-*.js の Flash.create（danger 10秒・それ以外 5秒、閉じる付き）、表示位置はフォーム先頭の <flash-message>
    this.flash.create(type, text, type === 'danger' ? 10000 : 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private resetInputs(form?: NgForm): void {
    this.select = { studioPlan: null, startDate: null };
    form?.resetForm({ studioPlanId: null, startDate: null });
  }
  private refreshClockDates(): void {
    this.startDateOptions = this.buildStartDateOptions(this.batchDay);
    this.select.startDate = null;
  }

}
